var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',_vm._b({staticClass:"payment-badge"},'b-badge',_vm.$attrs,false),[_vm._t("default",[_vm._v("Payment Status")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }